import styled, { keyframes } from "styled-components";
import * as Defines from '../../utils/defines/defines'

export const Container = styled.div`
    width: 100%;
    height: 100vh;
    background: ${Defines.BackgroundContainer};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 40px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    ${Defines.media.mobile`
        height: 100dvh;
        padding: 16px;
        overflow-y: auto;
        overflow-x: hidden;
        justify-content: flex-start;
    `}
`

const drift = keyframes`
    0%, 100% { transform: translate(0, 0); }
    50% { transform: translate(36px, -26px); }
`

export const BgLights = styled.div`
    position: absolute;
    inset: 0;
    z-index: 0;
    overflow: hidden;
    pointer-events: none;
`

export const BlobFixedBlue = styled.div`
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background: #5292D1;
    top: -100px;
    left: -60px;
    filter: blur(70px);
    opacity: 0.4;
    animation: ${drift} 10s ease-in-out infinite;
    ${Defines.media.mobile`
        width: 180px;
        height: 180px;
    `}
`

const desempenhoColor: Record<'ok' | 'atencao' | 'critico', { bg: string; opacity: number }> = {
    ok:      { bg: '#5292D1', opacity: 0.3 },
    atencao: { bg: '#E5D34A', opacity: 0.36 },
    critico: { bg: '#F03F3F', opacity: 0.48 },
}
const manutencaoColor: Record<'ok' | 'atencao' | 'critico', { bg: string; opacity: number }> = {
    ok:      { bg: '#92B258', opacity: 0.3 },
    atencao: { bg: '#E8A84C', opacity: 0.36 },
    critico: { bg: '#F03F3F', opacity: 0.48 },
}

export const BlobDesempenho = styled.div<{severity: 'ok' | 'atencao' | 'critico'}>`
    position: absolute;
    width: 340px;
    height: 340px;
    border-radius: 50%;
    top: 16%;
    left: 2%;
    filter: blur(80px);
    animation: ${drift} 10s ease-in-out infinite 1.5s;
    background: ${props => desempenhoColor[props.severity].bg};
    opacity: ${props => desempenhoColor[props.severity].opacity};
    transition: background .7s ease, opacity .7s ease;
    ${Defines.media.mobile`
        display: none;
    `}
`

export const BlobManutencao = styled.div<{severity: 'ok' | 'atencao' | 'critico'}>`
    position: absolute;
    width: 340px;
    height: 340px;
    border-radius: 50%;
    top: 42%;
    right: 2%;
    filter: blur(80px);
    animation: ${drift} 10s ease-in-out infinite 3s;
    background: ${props => manutencaoColor[props.severity].bg};
    opacity: ${props => manutencaoColor[props.severity].opacity};
    transition: background .7s ease, opacity .7s ease;
    ${Defines.media.mobile`
        display: none;
    `}
`

// Versões compactas, ancoradas dentro do próprio card (não no BgLights da página inteira) —
// usadas só no mobile, onde Desempenho/Manutenção empilham e os % do BgLights não acompanham.
export const CardGlowWrap = styled.div`
    position: relative;
    overflow: hidden;
    border-radius: 20px;
    width: 100%;
`

export const BlobDesempenhoCard = styled.div<{severity: 'ok' | 'atencao' | 'critico'}>`
    position: absolute;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    top: -70px;
    left: -70px;
    filter: blur(70px);
    background: ${props => desempenhoColor[props.severity].bg};
    opacity: ${props => desempenhoColor[props.severity].opacity};
    transition: background .7s ease, opacity .7s ease;
    pointer-events: none;
`

export const BlobManutencaoCard = styled.div<{severity: 'ok' | 'atencao' | 'critico'}>`
    position: absolute;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    top: -70px;
    right: -70px;
    filter: blur(70px);
    background: ${props => manutencaoColor[props.severity].bg};
    opacity: ${props => manutencaoColor[props.severity].opacity};
    transition: background .7s ease, opacity .7s ease;
    pointer-events: none;
`

export const Nav = styled.div`
    position: relative;
    z-index: 1;
    min-height: 60px;
    flex-shrink: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    ${Defines.media.mobile`
        flex-wrap: wrap;
        gap: 10px;
    `}
`

export const NavTitleContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
`

export const NavTitle = styled.p`
    margin: 0;
    font-family: "Montserrat";
    background: -webkit-linear-gradient(45deg, rgb(62, 147, 216), rgb(76, 185, 49));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent; 
    font-weight: 600;
    font-size: 35px;
    /* letter-spacing: 1.5px; */
    /* text-transform: uppercase; */
`
export const NavTitleWhite = styled.p`
    margin: 0;
    font-family: "Montserrat";
    color: rgba(255,255,255,0.8);
    font-weight: regular;
    font-size: 30px;
    letter-spacing: 1.5px;
`

export const UserImg = styled.img`
    height: 25px;
    width: 25px;
    border-radius: 50%;
`

export const NavSubtitle = styled.p`
    margin: 0;
    font-family: "Montserrat";
    color: ${Defines.TitleColor};
    font-weight: 300;
    font-size: 20px;
`

export const NavButtons = styled.div`
    display: flex;
    grid-gap: 0px 5px;
    ${Defines.media.mobile`
        flex-wrap: wrap;
    `}
`

export const NavMobileStack = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
`

export const NavSecondRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`

export const BtnIcon = styled.img`
    height: 20px;
    width: 20px;
`

export const Card = styled.div`
    width: 100%;
    background: ${Defines.GlassCardBg};
    border: ${Defines.GlassCardBorder};
    backdrop-filter: ${Defines.GlassCardBlur};
    box-shadow: ${Defines.GlassCardShadow};
    border-radius: 20px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const Content = styled.div`
    position: relative;
    z-index: 1;
    height: calc(100% - 60px);
    max-height: calc(100% - 60px);
    min-height: calc(100% - 60px);
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${Defines.media.mobile`
        flex-direction: column;
        align-items: stretch;
        height: auto;
        max-height: none;
        min-height: 0;
    `}
`

export const HalfContent = styled.div<{percentage: number}>`
    width: ${props => props.percentage}%;
    height: 100%;
    overflow-y: scroll;
    ::-webkit-scrollbar{
        display: none;
    }
    ${Defines.media.mobile`
        width: 100%;
        height: auto;
        overflow-y: visible;
        margin-top: 10px;
    `}
`

export const Title = styled.p`
    margin: 0;
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 25px;
    margin-bottom: 10px;
    color: ${Defines.TitleColor};
`

export const CardTitle = styled.div`
    height: 20px;
    border: 1px solid ${props => props.color};
    border-radius: 10px;
    padding-left: 5px; 
    padding-right: 5px;
    transition: .5s;
    transition-timing-function: ease-in;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;

`

export const TitleUHBG = styled.div`
    transition: .5s;
    transition-timing-function: ease-in;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 40px;
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
    padding-left: 15px;
    padding-right: 15px;
    align-items: center;
    box-sizing: border-box;
    background-color: #17212E;
    boder: 0px;
    border-radius: 20px;
`

export const Scroll = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    ::-webkit-scrollbar{
        display: none;
    }
    :hover{
        // ::-webkit-scrollbar{
        //     display: block;
        // }
    }
`

export const MoendaCard = styled.button`
    cursor: pointer;
    background: rgba(94, 94, 94, 0.1);
    backdrop-filter: blur(4px);
    border: none;
    border-radius: 20px;

    width: 100%;
    height: 90px;
    margin-bottom: 5px;
    padding: 20px;
    padding-left: 40px;
    padding-right: 40px;
    box-sizing: border-box;

    display: flex;
    justify-content: space-between;
    align-items: center;

`

export const ListCard = styled.button`
    cursor: pointer;
    background: rgba(94, 94, 94, 0.1);
    backdrop-filter: blur(4px);
    border: none;
    border-radius: 20px;

    width: 100%;
    margin-bottom: 5px;
    padding: 10px;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
`
export const ListText = styled.p`
    margin: 0;
    font-family: "Nunito";
    font-weight: 300;
    font-size: 16px;
    margin-bottom: 5px;
    color: rgba(255,255,255,0.8)
`

export const ListTitle = styled.p`
    margin: 0;
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 18px;
    color: ${Defines.TitleColor};
`

export const Circle = styled.div<{color: string}>`
    width: 40px;
    height: 40px;
    border: 2px solid ${props => props.color};
    border-radius: 50%;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
`
export const CircleTitle = styled.div<{color: string}>`
    width: 18px;
    height: 18px;
    border: 1px solid ${props => props.color};
    border-radius: 50%;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const IconTitle = styled.img`
    width: 10px;
    height: 10px;
`

export const CircleRed = styled.div`
    width: 15px;
    height: 15px;
    top: 2px;
    right: 20%;
    border: none;
    border-radius: 50%;
    background: red;
    position: absolute;
`

export const Row = styled.div`
    display: flex;
`

export const MoendaIcon = styled.img`
    height: 25px;
`

export const MoendaTextContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`

export const MoendaTitle = styled.p`
    margin: 0;
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 20px;
    transition: .5s;
    color: ${Defines.TitleColor};
    text-align: start;
`

export const MoendaText = styled.p`
    margin: 0;
    font-family: "Nunito";
    font-weight: 300;
    font-size: 16px;
    margin-bottom: 10px;
    color: rgba(255,255,255,0.8);
      -webkit-transition: 0.5s;
    -moz-transition: 0.5s;
    -o-transition: 0.5s;
    -ms-transition: 0.5s;
    transition: 0.5s
`

const maintenanceWash: Record<'ok' | 'atencao' | 'critico', string> = {
    ok: Defines.StatusWashOk,
    atencao: Defines.StatusWashAtencao,
    critico: Defines.StatusWashCritico,
}

export const MaintenanceCard = styled.div<{severity?: 'ok' | 'atencao' | 'critico'}>`
    cursor: pointer;
    width: 100%;
    background: ${props => maintenanceWash[props.severity ?? 'ok']};
    border: 1px solid rgba(255,255,255,0.09);
    backdrop-filter: blur(14px);
    border-radius: 20px;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
    overflow: hidden;

    margin-bottom: 10px;
    transition: .5s, background .3s ease;
`

export const MaintenanceInit = styled.div`
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const MaintenanceCardIcon = styled.img`
    height: 80px;
`

export const MaintenanceTitle = styled.p`
    margin: 0;
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 18px;
    color: ${Defines.TitleColor};
`

/* Gradient */
export const PickupGradient = styled.div``

export const CircleText = styled.p`
    margin: 0;
`

export const GradientContent = styled.div`
    position: relative;
    marigin-top: 10px;
    padding-top: 2px;
    min-height: 80px;
    box-sizing: border-border;
    width: 100%;
`
export const Pickup = styled.div<{left: number}>`
    top: 0;
    position: absolute;
    left: ${props => props.left}%;
`
export const TextPickup = styled.p`
    margin: 0;
    font-family: 'Nunito';
    font-size: 10px;
    color: #FFF;
    white-space: nowrap;
    margin-left: -30%;
`

export const RailPickup = styled.div`
    position: relative;
    margin-top: -10px;
    width: calc(100% - 8px);
`

export const CirclePickup = styled.div<{$small?: boolean}>`
    height: ${props => props.$small ? '10px' : '13px'};
    width: ${props => props.$small ? '10px' : '13px'};
    border-radius: 50%;
    background: #FFF;
    box-shadow: 0 0 0 ${props => props.$small ? '3px' : '4px'} rgba(255,255,255,0.15), 0 2px 6px rgba(0,0,0,0.4);
`

export const GradientCenter = styled.div`
    width: 100%;
    height: 7px;
    border-radius: 7px;
    background: linear-gradient(90deg, #F03F3F 5%, #E5D34A 15%, #92B258 25%, #92B258 50%, #92B258 75%, #E5D34A 85%, #F03F3F 95%);
`

export const GradientStart = styled.div`
    width: 100%;
    height: 7px;
    border-radius: 7px;
    background: linear-gradient(90deg, #92B258 20%, #E5D34A 25%, #E5D34A 43%, #F03F3F 48%);
`
export const GradientUmidade = styled.div`
    width: 100%;
    height: 7px;
    border-radius: 7px;
    background: linear-gradient(90deg, #92B258 40%, #E5D34A 41%, #E5D34A 60%, #F03F3F 61%);
`

// Autoteste da bomba: 0-4000psi vermelho, 4000-4400 amarelo, 4400-5200 verde, acima vermelho
// (escala do gauge de 0 a 6000psi) — ver AUTOTESTE_LIMITES em functions.tsx.
export const GradientAutoteste = styled.div`
    width: 100%;
    height: 7px;
    border-radius: 7px;
    background: linear-gradient(90deg, #F03F3F 66.67%, #E5D34A 66.67%, #E5D34A 73.33%, #92B258 73.33%, #92B258 86.67%, #F03F3F 86.67%);
`

export const ContentTimeUpdate = styled.div`
    position: absolute;
    bottom: 10px;
`

export const ConnectionBanner = styled.div`
    position: absolute;
    bottom: 50px;
    left: 40px;
    right: 40px;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 10px;
    background: ${Defines.StatusWashAtencao};
    border: 1px solid rgba(229, 211, 74, 0.25);
    backdrop-filter: blur(14px);
    border-radius: 16px;
    padding: 12px 20px;
    font-family: 'Nunito';
    font-size: 13px;
    font-weight: 300;
    color: rgba(255,255,255,0.85);
    ${Defines.media.mobile`
        position: relative;
        bottom: auto;
        left: auto;
        right: auto;
        width: 100%;
        margin-top: 12px;
        margin-bottom: 12px;
        flex-wrap: wrap;
        box-sizing: border-box;
    `}
`

// Mesmo layout do ConnectionBanner, mas com cor neutra — "moenda parada" é um estado esperado
// (não um problema), então não usa a mesma cor de atenção/alarme.
export const MoendaParadaBanner = styled.div`
    position: absolute;
    bottom: 50px;
    left: 40px;
    right: 40px;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 10px;
    background: ${Defines.StatusWashInativa};
    border: 1px solid rgba(255, 255, 255, 0.18);
    backdrop-filter: blur(14px);
    border-radius: 16px;
    padding: 12px 20px;
    font-family: 'Nunito';
    font-size: 13px;
    font-weight: 300;
    color: rgba(255,255,255,0.85);
    ${Defines.media.mobile`
        position: relative;
        bottom: auto;
        left: auto;
        right: auto;
        width: 100%;
        margin-top: 12px;
        margin-bottom: 12px;
        flex-wrap: wrap;
        box-sizing: border-box;
    `}
`

export const ConnPair = styled.div`
    display: flex;
    gap: 8px;
    margin-top: 6px;
`

export const ConnPill = styled.div<{ok: boolean}>`
    display: flex;
    align-items: center;
    gap: 5px;
    font-family: 'Nunito';
    font-size: 11px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 999px;
    background: ${props => props.ok ? 'rgba(146,178,88,0.16)' : 'rgba(240,63,63,0.16)'};
    color: ${props => props.ok ? '#92B258' : '#F03F3F'};
`